import { render, staticRenderFns } from "./SelectGroup.vue?vue&type=template&id=c670bb4a&scoped=true&"
import script from "./SelectGroup.vue?vue&type=script&lang=js&"
export * from "./SelectGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c670bb4a",
  null
  
)

export default component.exports